;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _Checkout = require("./components/Checkout.vue");

var _Checkout2 = _interopRequireDefault(_Checkout);

var _DisplayWallets = require("./components/DisplayWallets.vue");

var _DisplayWallets2 = _interopRequireDefault(_DisplayWallets);

var _InitPayment = require("./components/InitPayment.vue");

var _InitPayment2 = _interopRequireDefault(_InitPayment);

var _InitiateWithdrawal = require("./components/InitiateWithdrawal.vue");

var _InitiateWithdrawal2 = _interopRequireDefault(_InitiateWithdrawal);

var _ToastNotification = require("./components/ToastNotification.vue");

var _ToastNotification2 = _interopRequireDefault(_ToastNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["sid", "agent", "status_api_url", "csrf_token", "wallet_token", "telcos_prefixes", "wallet_types_to_show"],
  components: {
    Checkout: _Checkout2.default,
    DisplayWallets: _DisplayWallets2.default,
    InitPayment: _InitPayment2.default,
    InitiateWithdrawal: _InitiateWithdrawal2.default,
    ToastNotification: _ToastNotification2.default
  },
  data: function data() {
    return {
      fetchingWallets: false,
      showCheckout: false,
      showPayInvoice: false,
      checkoutRefNo: null,
      checkoutAmount: 0,
      checkoutMsisdn: "",
      topUpCurrency: "",
      allGateways: [],
      wallets: [],
      invoice: {},
      action: "viewWallets",
      selectedWalletId: null,
      showWithdraw: false,
      withdrawCurrency: ""
    };
  },
  mounted: function mounted() {
    if (this.agent) {
      this.loadWallets();
    }
  },

  methods: {
    handleBack: function handleBack() {
      this.showCheckout = false;
      this.showPayInvoice = false;
      this.showWithdraw = false;
      this.checkoutRefNo = null;
      this.checkoutAmount = 0;
      this.checkoutMsisdn = "";
      this.topUpCurrency = "";
      this.allGateways = [];
      this.invoice = {};
      this.selectedWalletId = null;
      this.withdrawCurrency = "";
      this.action = "viewWallets";

      this.loadWallets();
    },
    handleLogOut: async function handleLogOut() {
      this.isLoggingOut = true;

      try {
        var response = await Vue.axios.post("/wallet/checkout/signout", {}, {
          headers: this.getHeaders()
        });

        if (response.status === 200) {
          window.location.href = "/wallet/auth";
        }
      } catch (error) {
        console.error("Error during logout:", error);
      }
    },
    getHeaders: function getHeaders() {
      var contentType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "application/json";

      var headers = {
        "Content-Type": contentType
      };

      var csrfToken = this.csrf_token;
      if (csrfToken) {
        headers["x-csrf-token"] = csrfToken;
      }

      return headers;
    },
    loadWallets: async function loadWallets() {
      this.fetchingWallets = true;
      var agent = JSON.parse(this.agent);
      try {
        var response = await Vue.axios.get("/wallet/checkout/agent-wallets", {
          params: {
            agent_id: agent.id
          }
        });

        var data = Array.isArray(response.data) ? response.data : response.data.data || response.data.wallets || [];

        this.wallets = data.map(function (wallet) {
          return (0, _assign2.default)({}, wallet, {
            balance: parseFloat(wallet.balance) || "0"
          });
        });

        this.fetchingWallets = false;
      } catch (error) {
        this.fetchingWallets = false;
        console.error("Error loading wallets:", error);
      }
    },
    handleTopUp: function handleTopUp(data) {
      this.action = "topup";
      var self = this;
      var agent = data.agent;
      var amount = data.amount;
      this.topUpCurrency = data.currency;

      Vue.axios.post("/api/account/topup/create", {
        account_id: data.account_id,
        amount: amount,
        msisdn: agent.msisdn || "",
        metadata: {}
      }).then(function (res) {
        if (res.data && res.data.ref_no) {
          return Vue.axios.post("/wallet/checkout/topup/gateways", {
            amount: res.data.amount,
            ref: res.data.ref_no,
            currency: self.topUpCurrency
          }, {
            headers: self.getHeaders()
          }).then(function (response) {
            self.allGateways = response.data.gateways || [];
            self.checkoutRefNo = res.data.ref_no;
            self.checkoutAmount = parseFloat(res.data.amount);
            self.checkoutMsisdn = res.data.source || agent.msisdn || "";

            self.showCheckout = true;
          });
        } else {
          self.$refs.toast.show("Top-up failed. Please try again.");
        }
      }).catch(function (err) {
        if (err.response && err.response.status === 403) {
          window.location.href = "/wallet/auth";
          return;
        }
      });
    },
    cancelCheckout: function cancelCheckout() {
      this.showCheckout = false;
      this.checkoutRefNo = null;
      this.checkoutAmount = 0;
      this.showPayInvoice = false;
    },
    handlePayInvoice: function handlePayInvoice(data) {
      this.action = "initiatePayment";
      this.invoice = (0, _assign2.default)({}, data.invoice, {
        amount: parseFloat(data.invoice.amount) || 0
      });
      this.selectedWalletId = data.wallet_id;
      this.showPayInvoiceModal = false;
      this.showPayInvoice = true;
    },
    handlePaymentSuccess: function handlePaymentSuccess(data) {
      this.showPayInvoice = false;
      this.loadWallets();
    },
    handleWithdraw: function handleWithdraw(data) {
      this.showCheckout = false;
      this.showWithdraw = true;
      this.checkoutRefNo = null;
      this.fetchingWallets = false;
      this.selectedWalletId = data.walletId;
      this.withdrawCurrency = data.currency;
      this.action = "withdraw";
    },
    persistCurrentPage: function persistCurrentPage() {
      localStorage.setItem("currentPage", this.action);
    }
  },
  computed: {
    parsedAgent: function parsedAgent() {
      return this.agent ? JSON.parse(this.agent) : {};
    },
    baseUrl: function baseUrl() {
      return window.location.origin;
    },
    checkoutCallbackUrl: function checkoutCallbackUrl() {
      return window.location.href;
    },

    currentAction: function currentAction() {
      this.persistCurrentPage();
      return this.action;
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ToastNotification',{ref:"toast",attrs:{"type":"error"}}),_vm._v(" "),(_vm.currentAction === 'viewWallets' && this.wallets.length > 0)?_c('DisplayWallets',{attrs:{"agent":_vm.agent,"wallets":_vm.wallets,"wallet_types_to_show":_vm.wallet_types_to_show},on:{"top-up":_vm.handleTopUp,"pay-invoice":_vm.handlePayInvoice,"withdraw":_vm.handleWithdraw,"log_out":_vm.handleLogOut}}):_vm._e(),_vm._v(" "),(_vm.currentAction == 'topup')?_c('Checkout',{attrs:{"ref_no":_vm.checkoutRefNo,"amount":_vm.checkoutAmount,"msisdn":_vm.checkoutMsisdn,"currency":_vm.topUpCurrency,"gateways":_vm.allGateways,"baseUrl":_vm.baseUrl,"callbackUrl":_vm.checkoutCallbackUrl,"statusApiUrl":_vm.status_api_url,"wallet_token":_vm.wallet_token,"telcos_prefixes":_vm.telcos_prefixes},on:{"cancel":_vm.cancelCheckout,"back":_vm.handleBack}}):_vm._e(),_vm._v(" "),(_vm.showCheckout && !_vm.checkoutRefNo)?_c('p',{staticClass:"ac-loading-text"},[_vm._v("\n    Preparing checkout...\n  ")]):_vm._e(),_vm._v(" "),(_vm.currentAction == 'initiatePayment')?_c('InitPayment',{attrs:{"invoice":_vm.invoice,"wallets":_vm.wallets,"selectedWalletId":_vm.selectedWalletId,"agent":_vm.parsedAgent},on:{"cancel":_vm.cancelCheckout,"payment-success":_vm.handlePaymentSuccess,"back":_vm.handleBack}}):_vm._e(),_vm._v(" "),(_vm.currentAction == 'withdraw')?_c('InitiateWithdrawal',{attrs:{"walletId":_vm.selectedWalletId,"currency":_vm.withdrawCurrency,"agent":_vm.agent,"headers":_vm.getHeaders()},on:{"cancel":function($event){_vm.showWithdraw = false},"back":_vm.handleBack}}):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13290a5d", __vue__options__)
  } else {
    hotAPI.reload("data-v-13290a5d", __vue__options__)
  }
})()}